<!-- Searchbar -->
<div
  class="xl:relative h-2rem w-12 header__searchbar w-full"
  aria-label="client-search-container"
>
  <div class="hidden md:block h-full">
    <div
      class="h-1rem w-1rem border-round-left absolute p-3 bg-gray-600 flex align-items-center justify-content-center"
      aria-label="search-icon-container"
    >
      <i class="fa fa-search text-sm text-white" aria-label="search-icon"></i>
    </div>
    <input
      type="text"
      [formControl]="searchControl"
      (focus)="onSearchFocus()"
      [placeholder]="'CLIENT_OMNISEARCH.SEARCH_PLACEHOLDER' | translate"
      class="w-full border-none h-full border-round p-3 pl-6 bg-gray-800 text-white text-white-placeholder"
      aria-label="client-search-input"
    />
  </div>

  <!-- Searchbar Mobile -->
  <div
    pRipple
    class="border-1 border-primary cursor-pointer p-2 md:hidden flex align-items-center justify-content-center border-round bg-primary w-2rem h-2rem mr-2"
    pStyleClass=".omnisearch-wrapper"
    enterFromClass="hidden"
    enterActiveClass="fadein"
    leaveToClass="hidden"
    leaveActiveClass="fadeout"
    [hideOnOutsideClick]="true"
    aria-label="mobile-search-button"
  >
    <i class="fa fa-search" aria-label="mobile-search-icon"></i>
  </div>
  <!-- Searchbar Mobile -->

  <div
    class="omnisearch-wrapper w-full absolute right-0 top-0 mt-6 bg-gray-900 hidden md:block z-5"
    aria-label="search-results-container"
  >
    <!-- Search Bar -->
    <div
      class="flex md:hidden align-items-center justify-content-between relative p-2"
      aria-label="mobile-search-container"
    >
      <div
        class="h-1rem w-1rem border-round-left absolute p-3 bg-gray-600 flex align-items-center justify-content-center"
        aria-label="mobile-search-icon-container"
      >
        <i
          class="fa fa-search text-sm text-white"
          aria-label="mobile-search-icon"
        ></i>
      </div>
      <input
        type="text"
        [formControl]="searchControl"
        (focus)="onSearchFocus()"
        [placeholder]="'CLIENT_OMNISEARCH.SEARCH_PLACEHOLDER' | translate"
        class="w-full border-none h-full py-2 pl-6 pr-5 text-xs bg-gray-800 text-white shadow-none border-round"
        aria-label="mobile-client-search-input"
      />
      <div
        class="text-primary ml-2"
        pStyleClass=".omnisearch-wrapper"
        enterFromClass="hidden"
        leaveToClass="hidden"
        (click)="onCancelSearch()"
        aria-label="cancel-search-button"
      >
        Cancel
      </div>
    </div>
    <!-- Search Bar -->

    <!-- Recent Searches Dropdown -->
    @if (showRecentSearches.value) {
      <div
        class="omnisearch-dropdown md:absolute left-0 w-full bg-gray-900 shadow-1 border-round-bottom text-sm -mt-2"
        aria-label="recent-searches-dropdown"
      >
        <p-scrollPanel styleClass="text-sm" [style]="{ width: '100%' }">
          <!-- Recently Searched -->
          <div aria-label="recent-searches-section">
            <div
              class="p-3 border-bottom-1 border-gray-700 flex align-items-center text-500 font-bold"
              aria-label="recent-searches-header"
            >
              <i
                class="fa fa-clock-rotate-left mr-2"
                aria-label="recent-searches-icon"
              ></i>
              <span>{{ 'CLIENT_OMNISEARCH.RECENT_SEARCHED' | translate }}</span>
            </div>
            <div class="px-3 py-2">
              <ul
                class="list-none p-0 m-0 font-bold line-height-1"
                aria-label="recent-searches-list"
              >
                @for (term of recentSearches; track term; let i = $index) {
                  <li
                    (click)="onRecentSearchClick(term)"
                    class="text-blue-300 p-2 border-round cursor-pointer transition-linear transition-duration-500 hover:bg-gray-0-alpha-10"
                    [attr.aria-label]="'recent-search-term-' + i"
                  >
                    {{ term }}
                  </li>
                }
              </ul>
            </div>
          </div>
          <!-- Recently Searched -->
          <!-- Recently Viewed -->
          <div aria-label="recently-viewed-section">
            <div
              class="p-3 border-top-1 border-bottom-1 border-gray-700 flex align-items-center justify-content-between text-500 font-bold"
              aria-label="recently-viewed-header"
            >
              <div class="flex align-items-center">
                <i
                  class="fa fa-clock-rotate-left mr-2"
                  aria-label="recently-viewed-icon"
                ></i>
                <span>{{ 'CLIENT_OMNISEARCH.RECENT_VIEWED' | translate }}</span>
              </div>
            </div>
            <!-- Recently Viewed Clients -->
            <div class="p-3">
              <ul
                class="list-none m-0 p-0"
                aria-label="recently-viewed-clients-list"
              >
                @for (
                  client of recentlyViewedClients;
                  track client;
                  let i = $index
                ) {
                  <li
                    class="hover:bg-black-alpha-10 p-2 border-round mb-1 transition-linear transition-duration-500 border-2 border-gray-800 hover:border-primary bg-white-alpha-10 relative"
                    (mouseenter)="toggleClientDetails(client.clt_id, $event)"
                    (mouseleave)="toggleClientDetails(client.clt_id, $event)"
                    [attr.aria-label]="'recently-viewed-client-' + i"
                  >
                    <div class="md:flex align-items-center cursor-pointer">
                      <div
                        class="inline-flex align-items-center mb-2 md:mb-0"
                        (click)="onRecentClientClick(client)"
                        (click)="goToClientProfile(client.clt_id, 'overview')"
                        [attr.aria-label]="'client-profile-link-' + i"
                      >
                        @if (client.clt_image) {
                          <p-avatar
                            [image]="client.clt_image"
                            shape="circle"
                            [attr.aria-label]="'client-avatar-' + i"
                          />
                        }
                        @if (!client.clt_image) {
                          <p-avatar
                            [label]="
                              client.clt_full_name | titlecase | shortName
                            "
                            shape="circle"
                            [attr.aria-label]="'client-avatar-' + i"
                          />
                        }
                        <strong class="mx-2 text-blue-300 cursor-pointer">{{
                          client.clt_full_name
                        }}</strong>
                      </div>
                      <div class="flex align-items-center">
                        <span
                          class="bg-white-alpha-10 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2"
                          aria-label="phone-icon"
                        >
                          <i class="fa fa-phone text-xxs text-gray-500"></i>
                        </span>
                        <a
                          [href]="
                            'tel:' +
                            client.clt_mobile_country_code +
                            client.clt_mobile_no
                          "
                          class="text-gray-500"
                          aria-label="client-phone"
                        >
                          {{ client.clt_mobile_country_code }}
                          {{ client.clt_mobile_no }}
                        </a>
                      </div>
                      <div class="flex align-items-center md:mx-2 my-2 md:my-0">
                        <span
                          class="bg-white-alpha-10 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2"
                          aria-label="email-icon"
                        >
                          <i class="fa fa-envelope text-xxs text-gray-500"></i>
                        </span>
                        <a
                          [href]="'mailto:' + client.clt_emailid"
                          class="text-gray-500"
                          aria-label="client-email"
                          >{{ client.clt_emailid }}</a
                        >
                      </div>
                      <div
                        class="absolute right-0 top-0 mt-2 mr-2 md:static md:m-0"
                      >
                        <p-tag
                          styleClass="text-xs text-gray-700 bg-gray-400 font-bold white-space-nowrap mr-2"
                          aria-label="center-name-tag"
                        >
                          <div class="flex align-items-center gap-2">
                            <i
                              class="fa fa-location-dot"
                              aria-label="location-icon"
                            ></i>
                            <span>{{ getCenterName(client) }}</span>
                          </div>
                        </p-tag>
                        @if (client.is_child) {
                          <p-tag
                            styleClass="text-xs text-white bg-orange-500 font-bold white-space-nowrap mr-2"
                            value="Child"
                            aria-label="child-tag"
                          />
                        }
                        @if (getClientStatusHtml(client.clt_status); as data) {
                          <p-tag
                            [styleClass]="data.class"
                            [value]="data.text"
                            class="text-xs uppercase pl-2"
                            [attr.aria-label]="'client-status-' + data.text"
                          />
                        }
                      </div>
                      @if (
                        client.clt_track_mode &&
                        client.clt_track_mode.toLowerCase() ===
                          'clientwebsignup'
                      ) {
                        <span
                          class="text-600 fa fa-globe text-lg line-height-1 ml-3"
                          aria-label="web-signup-indicator"
                        ></span>
                      }
                    </div>
                    <div
                      [ngClass]="{
                        'max-h-0 opacity-0 -translate-y-2': !isClientExpanded(
                          client.clt_id
                        ),
                        'max-h-20rem opacity-100 translate-y-0':
                          isClientExpanded(client.clt_id),
                      }"
                      class="transition-all transition-duration-400 ease-in-out overflow-hidden transform transition-delay-150"
                    >
                      <!-- Details -->
                      <div
                        class="md:flex border-top-1 border-bottom-1 border-gray-800 py-2 my-2 text-gray-600"
                        (click)="$event.stopPropagation()"
                        aria-label="client-details-section"
                      >
                        <div class="flex align-items-center">
                          <span class="text-gray-600"
                            >{{
                              'CLIENT_OMNISEARCH.CLIENT.CLIENT_ID' | translate
                            }}: {{ client.clt_id }}</span
                          >
                        </div>
                        @if (client.clt_rep_id) {
                          <div
                            class="flex align-items-center mt-1 md:mt-0 md:ml-4 mr-3"
                            aria-label="client-rep-section"
                          >
                            <span
                              >{{
                                'CLIENT_OMNISEARCH.CLIENT.CLIENT_REP'
                                  | translate
                              }}:</span
                            >
                            @if (
                              getSalesRep(client.clt_rep_id) | async;
                              as salesRep
                            ) {
                              <div class="flex align-items-center">
                                @if (salesRep.staff_image) {
                                  <p-avatar
                                    [image]="salesRep.staff_image"
                                    styleClass="w-1rem h-1rem mx-2"
                                    shape="circle"
                                  />
                                }
                                @if (!salesRep.staff_image) {
                                  <p-avatar
                                    [label]="
                                      salesRep.name | titlecase | shortName
                                    "
                                    styleClass="w-1rem h-1rem mx-2"
                                    shape="circle"
                                  />
                                }
                                <strong class="text-blue-300">{{
                                  salesRep.name
                                }}</strong>
                              </div>
                            }
                          </div>
                        }
                        <div
                          class="mb-2 md:mb-0 md:mr-3 mr-3"
                          aria-label="client-source-section"
                        >
                          <span class="text-gray-600 text-xs mr-2"
                            >{{
                              'CLIENT_OMNISEARCH.CLIENT.SOURCE' | translate
                            }}:</span
                          >
                          <strong class="font-bold">{{
                            client.clt_source
                          }}</strong>
                        </div>
                        <div aria-label="client-channel-section">
                          <span class="text-gray-600 text-xs mr-2"
                            >{{
                              'CLIENT_OMNISEARCH.CLIENT.CHANNEL' | translate
                            }}:</span
                          >
                          <strong class="font-bold">{{
                            client.clt_channel
                          }}</strong>
                        </div>
                      </div>
                      <!-- Details -->
                      <!-- Quick Actions -->
                      <div
                        class="md:flex align-items-center text-gray-600 text-xs"
                        aria-label="quick-actions-section"
                      >
                        <div>
                          {{
                            'CLIENT_OMNISEARCH.CLIENT.QUICK_ACTIONS'
                              | translate
                          }}:
                        </div>
                        <p-button
                          icon="fa fa-contact-card"
                          [label]="
                            'CLIENT_OMNISEARCH.CLIENT.SUBSCRIPTIONS' | translate
                          "
                          styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                          (onClick)="
                            $event.stopPropagation();
                            goToClientProfile(client.clt_id, 'subscriptions')
                          "
                          [attr.aria-label]="'subscriptions-button-' + i"
                        />
                        <p-button
                          icon="fa fa-chart-line"
                          [label]="
                            'CLIENT_OMNISEARCH.CLIENT.CREATE_BILL' | translate
                          "
                          styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                          (onClick)="
                            $event.stopPropagation();
                            goToClientProfile(
                              client.clt_id,
                              'pos-addon-charges'
                            )
                          "
                          [attr.aria-label]="'create-bill-button-' + i"
                        />
                        <p-button
                          icon="fa fa-calendar-plus"
                          [label]="
                            'CLIENT_OMNISEARCH.CLIENT.BOOK_APPOINTMENT'
                              | translate
                          "
                          styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                          (onClick)="
                            $event.stopPropagation();
                            showBookAppointment(client.clt_id)
                          "
                          [attr.aria-label]="'book-appointment-button-' + i"
                        />
                        <p-button
                          icon="fa fa-calendar-plus"
                          [label]="
                            'CLIENT_OMNISEARCH.CLIENT.BOOK_CLASS' | translate
                          "
                          styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                          (onClick)="
                            $event.stopPropagation();
                            showBookClass(client.clt_id)
                          "
                          [attr.aria-label]="'book-class-button-' + i"
                        />
                        @if (client.clt_status.toLowerCase() !== 'prospect') {
                          <p-button
                            icon="fa fa-sign-in-alt"
                            [label]="
                              'CLIENT_OMNISEARCH.CLIENT.CHECK_IN' | translate
                            "
                            styleClass="text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                            (onClick)="
                              $event.stopPropagation();
                              goToClientProfile(client.clt_id, 'check-in')
                            "
                            [attr.aria-label]="'check-in-button-' + i"
                          />
                        }
                      </div>
                      <!-- Quick Actions -->
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
          <!-- Recently Viewed -->
          <!-- Action Buttons -->
          <div class="p-buttonset flex -mb-3" aria-label="action-buttons">
            <p-button
              class="w-3 h-3rem"
              icon="fa fa-user-plus"
              styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
              (onClick)="openPopup('prospect')"
              aria-label="create-prospect-button"
            >
              <span class="ml-2"
                ><span class="hidden md:inline">{{
                  'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
                }}</span>
                {{ 'CLIENT_OMNISEARCH.BUTTONS.PROSPECT' | translate }}</span
              >
            </p-button>
            <p-button
              class="w-3 h-3rem"
              icon="fa fa-person-walking-arrow-right"
              styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
              (onClick)="openPopup('walk-in-tour')"
              aria-label="create-walk-in-tour-button"
            >
              <span class="ml-2"
                ><span class="hidden md:inline">{{
                  'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
                }}</span>
                {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
                <br class="md:hidden" />
                {{ 'CLIENT_OMNISEARCH.BUTTONS.TOUR' | translate }}</span
              >
            </p-button>
            <p-button
              class="w-3 h-3rem"
              icon="fa fa-people-arrows"
              styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
              (onClick)="openPopup('walk-in-trial')"
              aria-label="create-walk-in-trial-button"
            >
              <span class="ml-2"
                ><span class="hidden md:inline">{{
                  'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
                }}</span>
                {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
                <br class="md:hidden" />
                {{ 'CLIENT_OMNISEARCH.BUTTONS.TRIAL' | translate }}</span
              >
            </p-button>
            <p-button
              class="w-3 h-3rem"
              icon="fa fa-person-walking"
              styleClass="border-none text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
              (onClick)="openPopup('walk-in-member')"
              aria-label="create-walk-in-member-button"
            >
              <span class="ml-2"
                ><span class="hidden md:inline">{{
                  'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
                }}</span>
                {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
                <br class="md:hidden" />
                {{ 'CLIENT_OMNISEARCH.BUTTONS.MEMBER' | translate }}</span
              >
            </p-button>
          </div>
        </p-scrollPanel>
      </div>
    }
    <!-- Recent Searches Dropdown -->

    <!-- Existing Omnisearch Dropdown -->
    @if (
      searchResults?.searchResults?.clients &&
      showResultDropdown.value &&
      searchControl.value
    ) {
      <div
        class="omnisearch-dropdown md:absolute left-0 w-full bg-gray-900 shadow-1 border-round-bottom text-sm -mt-2"
      >
        <!-- Search Result -->
        <div>
          <div
            class="p-3 border-top-1 border-bottom-1 border-gray-700 md:flex align-items-center justify-content-between text-gray-500"
          >
            <div class="md:flex align-items-center">
              @if (showAllProspects) {
                <p-button
                  (click)="BackToAllData()"
                  label="Back"
                  icon="fa fa-caret-left"
                  styleClass="text-sm p-0 p-button-text text-blue-300 font-bold mr-3"
                  aria-label="back-button"
                />
              }
              @if (selectedFilter === null) {
                <span class="block"
                  >{{ 'CLIENT_OMNISEARCH.SEARCH_RESULTS_CENTER' | translate }}
                  <strong class="font-bold">"{{ searchControl.value }}"</strong>
                  {{ 'CLIENT_OMNISEARCH.IN_THIS_CENTER' | translate }} ({{
                    selectedTenant?.name_primary_language ||
                      selectedTenant?.name_secondary_language
                  }}).
                  <span class="text-white font-bold block md:inline"
                    >{{ currentCentreClientsCount || 0 }}
                    {{ 'CLIENT_OMNISEARCH.RESULTS_FOUND' | translate }}.</span
                  ></span
                >
              }
              @if (selectedFilter !== null) {
                <span class="block">
                  {{ 'CLIENT_OMNISEARCH.SEARCH_RESULTS_CENTER' | translate }}
                  {{
                    selectedFilter.key === 'prospects'
                      ? ('CLIENT_OMNISEARCH.CLIENT.PROSPECT' | translate)
                      : selectedFilter.key === 'active'
                        ? ('CLIENT_OMNISEARCH.CLIENT.ACTIVE' | translate)
                        : selectedFilter.key === 'ex_client'
                          ? ('CLIENT_OMNISEARCH.CLIENT.EX_CLIENT' | translate)
                          : selectedFilter.key === 'blocked'
                            ? ('CLIENT_OMNISEARCH.CLIENT.BLOCKED' | translate)
                            : ''
                  }}
                  <strong class="font-bold">"{{ searchControl.value }}"</strong>
                  {{ 'CLIENT_OMNISEARCH.IN_THIS_CENTER' | translate }} ({{
                    selectedTenant?.name_primary_language ||
                      selectedTenant?.name_secondary_language
                  }}).
                  <span class="text-white font-bold block md:inline"
                    >{{ selectedFilter.value || 0 }}
                    {{ 'CLIENT_OMNISEARCH.RESULTS_FOUND' | translate }}.</span
                  >
                </span>
              }
            </div>
            @if (!showAllProspects) {
              <p-button
                (click)="toggleResultsForAllCentres()"
                [label]="'Show ' + allClientsCount + ' results for all centres'"
                icon="fa fa-angle-right"
                iconPos="right"
                styleClass="text-sm p-0 p-button-text text-blue-300 font-bold mt-2 md:mt-0"
                aria-label="show-all-centers-button"
              />
            }
          </div>
        </div>
        <!-- Result List -->
        <div class="md:flex">
          <!-- Left Side Mobile Up -->
          @if (!showAllProspects) {
            <div class="hidden md:block p-3 white-space-nowrap">
              <ul class="list-none m-0 p-0 text-gray-600">
                @for (
                  stat of searchResults?.searchResults?.clients?.statistics;
                  track stat;
                  let i = $index
                ) {
                  <li
                    (click)="selectedFilter = stat"
                    [ngClass]="{
                      'text-white font-bold': selectedFilter === stat,
                    }"
                    class="cursor-pointer md:w-8rem mb-3"
                    [attr.aria-label]="'filter-option-' + i"
                  >
                    {{
                      'CLIENT_OMNISEARCH.CLIENT.' + stat.label | translate
                    }}
                    ({{ stat.value }})
                  </li>
                }
              </ul>
            </div>
          }
          <!-- Left Side Mobile Up -->
          <!-- Left Side Mobile Only -->
          @if (!showAllProspects) {
            <div
              class="p-1 mx-3 mt-3 border-round-2xl text-xs md:hidden bg-black-alpha-90"
            >
              <ul
                class="flex justify-content-between list-none my-0 p-0 text-gray-600"
              >
                @for (
                  stat of searchResults?.searchResults?.clients?.statistics;
                  track stat;
                  let i = $index
                ) {
                  <li
                    (click)="selectedFilter = stat"
                    [ngClass]="{
                      'bg-white-alpha-10 text-primary font-bold':
                        selectedFilter === stat,
                      '': selectedFilter !== stat,
                    }"
                    class="py-1 px-2 border-round-2xl"
                    [attr.aria-label]="'mobile-filter-option-' + i"
                  >
                    {{
                      'CLIENT_OMNISEARCH.CLIENT.' + stat.label | translate
                    }}
                    ({{ stat.value }})
                  </li>
                }
              </ul>
            </div>
          }
          <!-- Left Side Mobile Only -->
          <!-- Right Side -->
          <div class="w-full p-3">
            <p-scrollPanel
              styleClass="text-sm"
              [style]="{ width: '100%', height: '65vh' }"
            >
              <!-- If No Result Found -->
              @if (searchResults?.searchResults?.clients?.items.length === 0) {
                <div class="text-center mt-4 mb-8">
                  <h6
                    class="text-gray-50 text-sm font-bold mb-1"
                    aria-label="no-results-title"
                  >
                    Well, this is awkward!
                  </h6>
                  <p
                    class="text-xs text-gray-600 mb-7"
                    aria-label="no-results-message"
                  >
                    Nothing is turning up with the word. Please try again!
                  </p>
                  <img
                    class="-ml-6"
                    width="170"
                    src="/assets/img/omnisearch-no-result-found.svg"
                    alt="No Result Found Image"
                    aria-label="no-results-image"
                  />
                </div>
              } @else {
                @for (
                  filter of selectedFilter !== null
                    ? [selectedFilter]
                    : searchResults?.searchResults?.clients?.statistics;
                  track filter
                ) {
                  <div class="mb-4">
                    <div
                      class="flex align-items-center text-gray-500 text-xs font-bold mb-2"
                    >
                      <span class="block">{{
                        'CLIENT_OMNISEARCH.CLIENT.' + filter?.label | translate
                      }}</span>
                      @if (!showAllProspects && filter?.value > 3) {
                        <span
                          (click)="toggleAllProspects(filter)"
                          class="block text-blue-300 cursor-pointer transition-linear transition-duration-500 hover:underline ml-3"
                          [attr.aria-label]="'show-all-button-' + filter?.label"
                          >{{
                            'CLIENT_OMNISEARCH.CLIENT.SHOW_ALL'
                              | translate: { count: filter?.value }
                          }}</span
                        >
                      }
                    </div>
                    <ul class="list-none m-0 p-0">
                      @for (
                        client of getSelectedFilterClients(
                          showAllProspects ? selectedFilter : filter
                        ).slice(0, showAllProspects ? filter?.value : 3);
                        track client;
                        let i = $index
                      ) {
                        <li
                          [ngClass]="
                            isClientExpanded(client.clt_id)
                              ? 'border-primary bg-black-alpha-10'
                              : 'bg-white-alpha-10'
                          "
                          class="hover:bg-black-alpha-10 p-2 border-round mb-1 transition-all transition-duration-400 ease-in-out border-2 border-gray-800 hover:border-primary overflow-hidden transform hover:scale-[1.01]"
                          (mouseenter)="
                            toggleClientDetails(client.clt_id, $event)
                          "
                          (mouseleave)="
                            toggleClientDetails(client.clt_id, $event)
                          "
                          [attr.aria-label]="'search-result-client-' + i"
                        >
                          <div class="md:flex align-items-center">
                            <div
                              class="inline-flex align-items-center mb-2 md:mb-0"
                              (click)="
                                goToClientProfile(client.clt_id, 'overview')
                              "
                              [attr.aria-label]="
                                'search-result-profile-link-' + i
                              "
                            >
                              @if (client.clt_image) {
                                <p-avatar
                                  [image]="client.clt_image"
                                  shape="circle"
                                  styleClass="cursor-pointer"
                                  [attr.aria-label]="
                                    'search-result-avatar-' + i
                                  "
                                />
                              }
                              @if (!client.clt_image) {
                                <p-avatar
                                  [label]="
                                    client.clt_full_name | titlecase | shortName
                                  "
                                  shape="circle"
                                  styleClass="cursor-pointer"
                                  [attr.aria-label]="
                                    'search-result-avatar-' + i
                                  "
                                />
                              }
                              <strong
                                class="mx-2 text-blue-300 cursor-pointer transition-colors duration-400 ease-in-out"
                                >{{ client.clt_full_name }}</strong
                              >
                            </div>
                            <div class="flex align-items-center">
                              <span
                                class="bg-white-alpha-10 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2"
                                aria-label="phone-icon"
                              >
                                <i
                                  class="fa fa-phone text-xxs text-gray-500"
                                ></i>
                              </span>
                              <a
                                [href]="
                                  'tel:' +
                                  client.clt_mobile_country_code +
                                  client.clt_mobile_no
                                "
                                class="text-gray-500 transition-colors duration-400 ease-in-out"
                                [attr.aria-label]="'search-result-phone-' + i"
                              >
                                {{ client.clt_mobile_country_code }}
                                {{ client.clt_mobile_no }}
                              </a>
                            </div>
                            <div
                              class="flex align-items-center md:mx-2 my-2 md:my-0"
                            >
                              <span
                                class="bg-white-alpha-10 w-1rem h-1rem border-circle flex align-items-center justify-content-center mr-2"
                                aria-label="email-icon"
                              >
                                <i
                                  class="fa fa-envelope text-xxs text-gray-500"
                                ></i>
                              </span>
                              <a
                                [href]="'mailto:' + client.clt_emailid"
                                class="text-gray-500 transition-colors duration-400 ease-in-out"
                                [attr.aria-label]="'search-result-email-' + i"
                                >{{ client.clt_emailid }}</a
                              >
                            </div>
                            <div
                              class="flex align-items-center md:mx-2 my-2 md:my-0"
                            >
                              @if (client.is_child) {
                                <p-tag
                                  styleClass="text-xs text-white bg-orange-500 font-bold white-space-nowrap mr-2"
                                  value="Child"
                                  aria-label="search-result-child-tag"
                                />
                              }
                            </div>
                            @if (
                              client.clt_track_mode &&
                              client.clt_track_mode.toLowerCase() ===
                                'clientwebsignup'
                            ) {
                              <span
                                class="text-600 fa fa-globe text-lg line-height-1 ml-3 cursor-pointer"
                                aria-label="web-signup-indicator"
                              ></span>
                            }
                          </div>
                          <div
                            [ngClass]="{
                              'max-h-0 opacity-0 -translate-y-2':
                                !isClientExpanded(client.clt_id),
                              'max-h-20rem opacity-100 translate-y-0':
                                isClientExpanded(client.clt_id),
                            }"
                            class="transition-all transition-duration-400 ease-in-out overflow-hidden transform transition-delay-150"
                          >
                            <!-- Details -->
                            <div
                              class="md:flex border-top-1 border-bottom-1 border-gray-800 py-2 my-2 text-gray-600"
                              (click)="$event.stopPropagation()"
                              [attr.aria-label]="'search-result-details-' + i"
                            >
                              <div class="flex align-items-center">
                                <span class="text-gray-600"
                                  >{{
                                    'CLIENT_OMNISEARCH.CLIENT.CLIENT_ID'
                                      | translate
                                  }}: {{ client.clt_id }}</span
                                >
                              </div>
                              @if (client.clt_rep_id) {
                                <div
                                  class="flex align-items-center mt-1 md:mt-0 md:ml-4 mr-3"
                                  [attr.aria-label]="
                                    'search-result-rep-section-' + i
                                  "
                                >
                                  <span
                                    >{{
                                      'CLIENT_OMNISEARCH.CLIENT.CLIENT_REP'
                                        | translate
                                    }}:</span
                                  >
                                  @if (
                                    getSalesRep(client.clt_rep_id) | async;
                                    as salesRep
                                  ) {
                                    <div class="flex align-items-center">
                                      @if (salesRep.staff_image) {
                                        <p-avatar
                                          [image]="salesRep.staff_image"
                                          styleClass="w-1rem h-1rem mx-2"
                                          shape="circle"
                                        />
                                      }
                                      @if (!salesRep.staff_image) {
                                        <p-avatar
                                          [label]="
                                            salesRep.name
                                              | titlecase
                                              | shortName
                                          "
                                          styleClass="w-1rem h-1rem mx-2"
                                          shape="circle"
                                        />
                                      }
                                      <strong class="text-blue-300">{{
                                        salesRep.name
                                      }}</strong>
                                    </div>
                                  }
                                </div>
                              }
                              <div
                                class="mb-2 md:mb-0 md:mr-3 mr-3"
                                [attr.aria-label]="
                                  'search-result-source-section-' + i
                                "
                              >
                                <span class="text-gray-600 text-xs mr-2"
                                  >{{
                                    'CLIENT_OMNISEARCH.CLIENT.SOURCE'
                                      | translate
                                  }}:</span
                                >
                                <strong class="font-bold">{{
                                  client.clt_source
                                }}</strong>
                              </div>
                              <div
                                [attr.aria-label]="
                                  'search-result-channel-section-' + i
                                "
                              >
                                <span class="text-gray-600 text-xs mr-2"
                                  >{{
                                    'CLIENT_OMNISEARCH.CLIENT.CHANNEL'
                                      | translate
                                  }}:</span
                                >
                                <strong class="font-bold">{{
                                  client.clt_channel
                                }}</strong>
                              </div>
                            </div>
                            <!-- Details -->
                            <!-- Quick Actions -->
                            <div
                              class="md:flex align-items-center text-gray-600 text-xs"
                              [attr.aria-label]="'search-result-actions-' + i"
                            >
                              <div>
                                {{
                                  'CLIENT_OMNISEARCH.CLIENT.QUICK_ACTIONS'
                                    | translate
                                }}:
                              </div>
                              <p-button
                                icon="fa fa-contact-card"
                                [label]="
                                  'CLIENT_OMNISEARCH.CLIENT.SUBSCRIPTIONS'
                                    | translate
                                "
                                styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                                (onClick)="
                                  $event.stopPropagation();
                                  goToClientProfile(
                                    client.clt_id,
                                    'subscriptions'
                                  )
                                "
                                [attr.aria-label]="
                                  'search-result-subscriptions-button-' + i
                                "
                              />
                              <p-button
                                icon="fa fa-chart-line"
                                [label]="
                                  'CLIENT_OMNISEARCH.CLIENT.CREATE_BILL'
                                    | translate
                                "
                                styleClass="block md:inline-flex text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                                (onClick)="
                                  $event.stopPropagation();
                                  goToClientProfile(
                                    client.clt_id,
                                    'pos-addon-charges'
                                  )
                                "
                                [attr.aria-label]="
                                  'search-result-create-bill-button-' + i
                                "
                              />
                              <p-button
                                icon="fa fa-calendar-plus"
                                [label]="
                                  'CLIENT_OMNISEARCH.CLIENT.BOOK_APPOINTMENT'
                                    | translate
                                "
                                styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                                (onClick)="
                                  $event.stopPropagation();
                                  showBookAppointment(client.clt_id)
                                "
                                [attr.aria-label]="
                                  'search-result-book-appointment-button-' + i
                                "
                              />
                              <p-button
                                icon="fa fa-calendar-plus"
                                [label]="
                                  'CLIENT_OMNISEARCH.CLIENT.BOOK_CLASS'
                                    | translate
                                "
                                styleClass="block md:inline-flex p-0 text-sm text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                                (onClick)="
                                  $event.stopPropagation();
                                  showBookClass(client.clt_id)
                                "
                                [attr.aria-label]="
                                  'search-result-book-class-button-' + i
                                "
                              />
                              @if (
                                client.clt_status.toLowerCase() !== 'prospect'
                              ) {
                                <p-button
                                  icon="fa fa-sign-in-alt"
                                  [label]="
                                    'CLIENT_OMNISEARCH.CLIENT.CHECK_IN'
                                      | translate
                                  "
                                  styleClass="text-sm p-0 text-primary p-button-text py-1 md:ml-3 font-bold md:font-normal"
                                  (onClick)="
                                    $event.stopPropagation();
                                    goToClientProfile(client.clt_id, 'check-in')
                                  "
                                  [attr.aria-label]="
                                    'search-result-check-in-button-' + i
                                  "
                                />
                              }
                            </div>
                            <!-- Quick Actions -->
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                }
              }
              <!-- If No Result Found -->
              <!-- Client Results -->
            </p-scrollPanel>
          </div>
          <!-- Right Side -->
        </div>
        <!-- Action Buttons -->
        <div class="p-buttonset flex">
          <p-button
            class="w-3 h-3rem"
            icon="fa fa-user-plus"
            styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
            (onClick)="openPopup('prospect')"
            aria-label="create-prospect-button"
          >
            <span class="ml-2"
              ><span class="hidden md:inline">{{
                'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
              }}</span>
              {{ 'CLIENT_OMNISEARCH.BUTTONS.PROSPECT' | translate }}</span
            >
          </p-button>
          <p-button
            class="w-3 h-3rem"
            icon="fa fa-person-walking-arrow-right"
            styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
            (onClick)="openPopup('walk-in-tour')"
            aria-label="create-walk-in-tour-button"
          >
            <span class="ml-2"
              ><span class="hidden md:inline">{{
                'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
              }}</span>
              {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
              <br class="md:hidden" />
              {{ 'CLIENT_OMNISEARCH.BUTTONS.TOUR' | translate }}</span
            >
          </p-button>
          <p-button
            class="w-3 h-3rem"
            icon="fa fa-people-arrows"
            styleClass="border-none border-right-1 border-white text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
            (onClick)="openPopup('walk-in-trial')"
            aria-label="create-walk-in-trial-button"
          >
            <span class="ml-2"
              ><span class="hidden md:inline">{{
                'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
              }}</span>
              {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
              <br class="md:hidden" />
              {{ 'CLIENT_OMNISEARCH.BUTTONS.TRIAL' | translate }}</span
            >
          </p-button>
          <p-button
            class="w-3 h-3rem"
            icon="fa fa-person-walking"
            styleClass="border-none text-xs md:text-sm w-full h-full flex-row-reverse justify-content-end px-2 md:px-3 text-left"
            (onClick)="openPopup('walk-in-member')"
            aria-label="create-walk-in-member-button"
          >
            <span class="ml-2"
              ><span class="hidden md:inline">{{
                'CLIENT_OMNISEARCH.BUTTONS.CREATE' | translate
              }}</span>
              {{ 'CLIENT_OMNISEARCH.BUTTONS.WALK_IN' | translate }}
              <br class="md:hidden" />
              {{ 'CLIENT_OMNISEARCH.BUTTONS.MEMBER' | translate }}</span
            >
          </p-button>
        </div>
      </div>
    }
    <!-- Existing Omnisearch Dropdown -->
  </div>
</div>
<!-- Searchbar -->

<!-- Sidebar Component -->
@if (showResultsForAllCentres) {
  <app-client-search-sidebar
    [visible]="showResultsForAllCentres"
    [searchQuery]="searchControl.value"
    [totalCount]="searchResults?.searchResults?.clients?.total_items"
    [goToClientProfile]="boundGoToClientProfile"
    (close)="closeSidebar()"
    aria-label="all-centers-search-sidebar"
  />
}
<!-- Sidebar Component -->

@if (showBookAppointmentPopup) {
  <book-appointment
    [visible]="showBookAppointmentPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [clientId]="clientId"
    [startDateTime]="selectedDateTime"
    [tenantId]="tenantId"
    (CloseBookAppointment)="CloseBookAppointment($event)"
    aria-label="book-appointment-dialog"
  />
}

@if (showBookClassPopup) {
  <p-dialog
    [visible]="showBookClassPopup"
    (onHide)="closePopup(false)"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '1050px' }"
    styleClass="no-header-modal overflow-visible book-class-popup"
    aria-label="book-class-dialog"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
        aria-label="book-class-header"
      >
        <h2 class="mb-0 text-sm">
          <i class="fa fa-plus mr-3 text-500" aria-label="add-icon"></i
          >{{ 'CLIENT_OMNISEARCH.CLIENT.BOOK_CLASS' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closePopup(false)"
          aria-label="close-dialog-button"
        ></div>
      </div>
      <!-- Header -->
      <!-- Content -->
      <div class="surface-100 text-sm">
        <!-- Loading Overlay -->
        @if (isBookingClass) {
          <div
            class="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5"
            style="background: rgba(0, 0, 0, 0.3)"
            aria-label="loading-overlay"
          >
            <p-progressSpinner
              styleClass="w-4rem h-4rem"
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration=".5s"
              aria-label="loading-spinner"
            />
          </div>
        }
        <!-- Loading Overlay -->
        <div class="m-5">
          <calendar
            [onlyTrialAllowed]="true"
            (emitEvents)="getEventData($event)"
            aria-label="class-calendar"
          />
        </div>
      </div>
      <!-- Content -->
    </ng-template>
  </p-dialog>
}
